// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"958561d4","133":"b423b61a","568":"0923bdca","888":"6c605d4f","971":"ef148526"}[chunkId] + ".chunk.js";
};